export default "__VITE_ASSET__jYHsBPSo__"